// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import ButtonRegular from '/react4xp/components/ButtonRegular'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface ListEntryCardsProps {
    bgColor: 'green' | 'beige'
    title?: string
    entryCards: Array<{
        image: {
            srcMedium: string
            src: string
            alt?: string
        }
        title?: string
        intro?: string
        cta?: {
            label: string
            href: string
            isExternal?: boolean
        }
    }>
}

export default function ListEntryCards({
    bgColor,
    title,
    entryCards
}: ListEntryCardsProps) {
    return (
        <Section
            bgColor={clsx(
                bgColor === 'beige' && 'bg-beige-primary-dark',
                bgColor === 'green' && 'bg-green-secondary-dark'
            )}
            textColor='text-dark'
            className='list-entry-cards'
        >
            <div className='grid-container'>

                {isNonWhitespaceString(title) && (
                    <div className='list-entry-cards__header'>
                        <h2 className='title-md title'>
                            {title}
                        </h2>
                    </div>
                )}

                {entryCards && entryCards.length > 0 && (
                    <div className={clsx(
                        'list-entry-cards__cards',
                        !title && 'list-entry-cards__cards--no-title'
                    )}>
                        {entryCards.map((item, i) => (
                            <div key={i} className='entry-card-wrapper'>

                                <div className={clsx(
                                    'entry-card-wrapper__image',
                                    !item.image && 'entry-card-wrapper__image--no-image'
                                )}>
                                    {item.image && (
                                        <Image
                                            srcMedium={[`${item.image.srcMedium}`, 574]} // 400x350
                                            src={item.image.src} // 700x400
                                            alt={item.image.alt}
                                            className='cover'
                                        />
                                    )}
                                </div>

                                <div className='entry-card-wrapper__content'>

                                    {isNonWhitespaceString(item.title) && (
                                        <h3 className='title-sm content__title'>
                                            {item.title}
                                        </h3>    
                                    )}

                                    {isNonWhitespaceString(item.intro) && (
                                        <div
                                            dangerouslySetInnerHTML={{ __html: item.intro }}
                                            suppressHydrationWarning
                                            className='content__intro'
                                        />
                                    )}
                                    
                                    {isNonWhitespaceString(item.cta?.label) && isNonWhitespaceString(item.cta?.href) && (
                                        <ButtonRegular
                                            text={item.cta.label}
                                            href={item.cta.href}
                                            target={item.cta.isExternal}
                                            className='content__button'
                                            icon={{
                                                svg: "<svg width='14' height='12' viewBox='0 0 14 12' xmlns='http://www.w3.org/2000/svg'><path d='M7.9998 0.510254L13.4898 6.0002L7.9998 11.4902L7.00985 10.5002L10.8099 6.7002H0.799805V5.3002H10.8099L7.00985 1.5002L7.9998 0.510254Z'/></svg>",
                                                position: 'right'
                                            }}
                                        />
                                    )}

                                </div>

                            </div>
                        ))}
                    </div>
                )}
                
            </div>
        </Section>
    )
}

